var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconShipArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 144,
    viewBox: "0 0 144 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_406_10661)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81 15.8587C81 16.1514 80.8718 16.4294 80.6491 16.6194L72.6491 23.4461C72.2752 23.7652 71.7248 23.7652 71.3509 23.4461L63.3509 16.6194C63.1282 16.4294 63 16.1514 63 15.8587L63 1.66667C63 0.911745 63.8045 0.429056 64.4706 0.784313L71.5294 4.54902C71.8235 4.70588 72.1765 4.70588 72.4706 4.54902L79.5294 0.784311C80.1955 0.429054 81 0.911744 81 1.66666L81 15.8587Z",
    fill: "#FF4D58"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_406_10661"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 144,
    height: 144,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShipArrow);
export default __webpack_public_path__ + "static/media/icon_ship_arrow.cbcbcfcbd91c1ee7c85f169d8ab7b9db.svg";
export { ForwardRef as ReactComponent };